export default __webpack_public_path__ + "static/media/princess.385efb6c.webp";